import styled, { css } from 'styled-components';

const StepsWrapper = /*#__PURE__*/styled('ol').withConfig({
  componentId: "sc-storm-ui-30061128__sc-152rut-0"
})(["display:flex;margin:0;", ""], ({
  $isVertical
}) => $isVertical && css(["flex-direction:column;"]));

export { StepsWrapper as S };
//# sourceMappingURL=Steps.styles-BTf5oABI.js.map
